import * as React from 'react';
import { IValuationFiltersProps } from '../../types/public';
import * as styles from './styles.css';

export const ValuationFiltersMobile: React.FC<Partial<IValuationFiltersProps>> = ({
  mainFiltersWidget,
  valuationFiltersSubmit,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['filters']}>{mainFiltersWidget}</div>
      {valuationFiltersSubmit}
    </div>
  );
};

ValuationFiltersMobile.displayName = 'ValuationFiltersMobile';
